/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiARewindBackIcon24Solid = forwardRef('MediaUiARewindBackIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m9.322 4.385-8.44 5.938a2.05 2.05 0 0 0 0 3.354l8.44 5.938c1.126.793 2.678-.013 2.678-1.39v-4.466l8.322 5.856c1.126.793 2.678-.013 2.678-1.39V5.775c0-1.377-1.552-2.183-2.678-1.39L12 10.24V5.775c0-1.377-1.552-2.183-2.678-1.39Z" })));
});
